<div class="container document-type">
	@if (selectedType) {
		<mat-icon [class]="selectedType?.icon" [svgIcon]="selectedType.icon" />
	}
	<au-body-text [text]="selectedType?.name || '' | translate" [smallFont]="smallFont" />
</div>
